import { UserId } from "@nimble/datamodel/types/userId";
import { raisableFetch } from "@nimble/react-requests/api-clients/fetch-config";
import { client } from "@nimble/recommendation-client/client";
import {
  createActionApiUserAuthV1ActionPost,
  expressInterestApiUserAuthV1MatchesExpressInterestPost,
  generateCandidatePreferenceWeightsApiUserAuthV1RecommendationCandidatePreferenceWeightsPost,
  generateRecommendationsForCandidateApiUserAuthV1RecommendationCandidateGeneratePost,
  getCandidateCountsApiUserAuthV1RecommendationCandidateCountsGet,
  getCandidateInvitationsApiUserAuthV1InvitationsGet,
  getCandidateRecommendationsEndpointApiUserAuthV1RecommendationCandidateGet,
  getConnectionsApiUserAuthV1ConnectionsCandidateGet,
  getConnectionsCountApiUserAuthV1ConnectionsCountGet,
  getMatchStatusApiUserAuthV1MatchesStatusPost,
  getQuizQuestionsApiUserAuthV1QuizQuestionsGet,
  getQuizStatusApiUserAuthV1QuizStatusGet,
  saveResponseApiUserAuthV1QuizResponsesPost,
} from "@nimble/recommendation-client/sdk";
import type {
  ActionEvent,
  CandidateQuizResponse,
  CandidateRecommendationInput,
  ExpressInterestRequest,
  GatewayActionRequest,
  MatchStatusRequest,
  MessageEvent,
} from "@nimble/recommendation-client/types";

import { REVERSE_PROXY_GATEWAY_PATH } from "@/lib/constants";

export type {
  CandidateCountsResponse,
  ConnectionItem,
  ExpressInterestRequest,
  InvitationsResponse,
  PrincipalContact,
  QuizStatusResponse,
} from "@nimble/recommendation-client/types";

export type TimelineEvent = ActionEvent | MessageEvent;

export {
  ActionTypeEnum,
  MatchActorEnum,
  MatchStatusEnum,
} from "@nimble/recommendation-client/types";

client.setConfig({
  baseUrl: `${REVERSE_PROXY_GATEWAY_PATH}/recommendation`,
  fetch: raisableFetch,
});

export async function fetchQuizQuestions(userId: UserId) {
  return await getQuizQuestionsApiUserAuthV1QuizQuestionsGet({
    headers: {
      "x-user-id": userId.toString(),
    },
  });
}

export async function fetchQuizStatus(userId: UserId) {
  return await getQuizStatusApiUserAuthV1QuizStatusGet({
    headers: {
      "x-user-id": userId.toString(),
    },
  });
}

export async function submitQuizResponses(
  userId: UserId,
  responses: CandidateQuizResponse[],
) {
  return await saveResponseApiUserAuthV1QuizResponsesPost({
    body: {
      responses,
    },
    headers: {
      "x-user-id": userId.toString(),
    },
  });
}

export async function generateCandidateRecommendations(
  userId: UserId,
  request: CandidateRecommendationInput,
) {
  return await generateRecommendationsForCandidateApiUserAuthV1RecommendationCandidateGeneratePost(
    {
      body: request,
      headers: {
        "x-user-id": userId.toString(),
      },
    },
  );
}

export async function generateCandidatePreferenceWeights(userId: UserId) {
  return await generateCandidatePreferenceWeightsApiUserAuthV1RecommendationCandidatePreferenceWeightsPost(
    {
      headers: {
        "x-user-id": userId.toString(),
      },
    },
  );
}

export async function getInvitations(userId: UserId) {
  return await getCandidateInvitationsApiUserAuthV1InvitationsGet({
    headers: {
      "x-user-id": userId.toString(),
    },
  });
}

export async function getConnectionsCount(userId: UserId) {
  return await getConnectionsCountApiUserAuthV1ConnectionsCountGet({
    headers: {
      "x-user-id": userId.toString(),
    },
  });
}

export async function getCandidateCounts(userId: UserId) {
  return getCandidateCountsApiUserAuthV1RecommendationCandidateCountsGet({
    headers: {
      "x-user-id": userId.toString(),
    },
  });
}

export async function createAction(userId: UserId, body: GatewayActionRequest) {
  return await createActionApiUserAuthV1ActionPost({
    body: body,
    headers: {
      "x-user-id": userId.toString(),
    },
  });
}

export async function getConnections(userId: UserId) {
  return await getConnectionsApiUserAuthV1ConnectionsCandidateGet({
    headers: {
      "x-user-id": userId.toString(),
    },
  });
}

export async function getCandidateRecommendations(userId: UserId) {
  return await getCandidateRecommendationsEndpointApiUserAuthV1RecommendationCandidateGet(
    {
      headers: {
        "x-user-id": userId.toString(),
      },
    },
  );
}

export async function expressInterest(
  userId: UserId,
  body: ExpressInterestRequest,
) {
  return expressInterestApiUserAuthV1MatchesExpressInterestPost({
    body,
    headers: {
      "x-user-id": userId.toString(),
    },
  });
}

export async function getMatchStatus(userId: UserId, body: MatchStatusRequest) {
  return getMatchStatusApiUserAuthV1MatchesStatusPost({
    body,
    headers: {
      "x-user-id": userId.toString(),
    },
  });
}
